import { z } from "zod";

// TES-1205 — ending every app session a patient has, from our side.
//
// A patient's app token used to be good until its 12 h session cap, whatever
// happened to the phone it sat on. Patient.sessionsValidAfter now ends every
// session that began before it: the API answers 401, and the app signs out.
// Three writers set it:
//   - erasure (Article 17), as part of anonymising the patient;
//   - support, "Logga ut patienten från alla enheter" in the admin's patient
//     view, when she reports a lost or stolen phone;
//   - the patient herself, "Logga ut på alla enheter" in Profil (app 2.0.9).

/**
 * Why support ended a patient's sessions. A fixed list, not free text: the
 * reason goes into the audit log, and free text about a patient never does
 * (TES-1035).
 */
export const PATIENT_SESSION_REVOCATION_REASONS = [
  "lost_device",
  "patient_request",
  "suspected_misuse",
] as const;
export type PatientSessionRevocationReason =
  (typeof PATIENT_SESSION_REVOCATION_REASONS)[number];

// POST employee-api/v1/patients/:id/sessions/revoke (admin only).
export const revokePatientSessionsSchema = z.object({
  reason: z.enum(PATIENT_SESSION_REVOCATION_REASONS),
});
export type RevokePatientSessionsRequest = z.infer<
  typeof revokePatientSessionsSchema
>;

// The answer to both the admin route and the patient's own
// POST patient-api/v1/me/sessions/revoke.
export const patientSessionsRevokedSchema = z.object({
  /** Every session that began at or before this instant is refused (ISO). */
  sessionsValidAfter: z.string(),
});
export type PatientSessionsRevoked = z.infer<
  typeof patientSessionsRevokedSchema
>;
